/**
 * Import required libraries
 */
import React from "react";

/**
 * Import required elements
 */
import { Typography, InputLabel } from "@material-ui/core";
import styles from "./styles";

/**
 * Label Component
 */
function Label(props) {
  const { Icon, text } = props;
  // CSS classnames
  const classes = styles();

  return (
    <InputLabel className={classes.root}>
      {Icon && <Icon className={classes.icon} />}
      <Typography noWrap className={classes.text}>
        {text}
      </Typography>
    </InputLabel>
  );
}

export default Label;
